import { useAuth } from "@/context/AuthContext";

export function usePermission(module) {
  const { user } = useAuth();
  // Master admins always have full access
  if (user?.is_master) return { canView: true, canEdit: true, isViewOnly: false };
  const perms = user?.permissions || {};
  // Restrictive default: unset permission = no access
  const level = perms[module] || "none";
  return {
    canView: level !== "none",
    canEdit: level === "full",
    isViewOnly: level === "view",
  };
}
